import * as React from 'react'
import {
    DragDropContext,
    Droppable, DroppableProvided,
    OnDragEndResponder,
} from 'react-beautiful-dnd'
import TableHideColumnDrawerItem from '@/components/detail/DetailTable/TableToolbar/TableHideColumnDrawer/TableHideColumnDrawerItem'
import { PageType } from '@/store/reducers'

export type DraggableListProps = {
    items: Array<any>
    onDragEnd: OnDragEndResponder
    pageType: PageType
}

const DragDropContextAny = DragDropContext as unknown as React.FC<any>
const DroppableAny = Droppable as unknown as React.FC<any>

const TableHideColumnDrawerList = React.memo(
    ({ items, onDragEnd, pageType }: DraggableListProps) => {
        return (
            <DragDropContextAny onDragEnd={onDragEnd}>
                <DroppableAny droppableId='droppable-list'>
                    {(provided: DroppableProvided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            <>
                                {items.map((item, index) => (
                                    <TableHideColumnDrawerItem
                                        item={item}
                                        index={index}
                                        key={index}
                                        pageType={pageType}
                                    />
                                ))}
                                {provided.placeholder}
                            </>
                        </div>
                    )}
                </DroppableAny>
            </DragDropContextAny>
        )
    }
)

TableHideColumnDrawerList.displayName = 'TableHideColumnDrawerList'

export default TableHideColumnDrawerList
